module.exports = {
  game: 'Game',
  gameNameTranslations: {
    'bingo90': 'bingo 90',
    'classic': 'Classic',
    'egyptian': 'Egipto',
    'suits': 'Cards',
    'deep': 'Viaje Submarino',
    'sacred': 'Templo Perdido',
    'goldrush': 'Fiebre del Oro',
    'tribe': 'Tribu',
    'bubble': 'Bubble',
    'galleon': 'Galeón',
    'phoenix': 'Fénix',
    'carnival': 'Feria',
    'invasion': 'OVNI',
    'vikings': 'Vikingos',
    'pirate': 'Maldición Pirata',
    'emoji': 'Emoji',
    'numbers': 'Numbers',
    'temple': 'Sultán',
    'parade': 'Mascarada',
    'wanted': 'Salvaje Oeste',
    'wildwood': 'Bosque Encantado',
    'picture bingo': 'FotoBingo',
    'bankbonus': 'Deal or No Deal: Caja Sorpresa',
    'bankvault': 'Deal or No Deal: Caja Fuerte'
  },
  prize: {
    currencySymbol: '€',
    currencySymbolForPennies: '€'
  },
  jackpot: {
    won: 'JACKPOT WON',
    notWon: 'No jackpot winners this game',
    title: 'Jackpot'
  },
  winners: {
    gameWinnersModalTitle: 'Winners',
    previousGameWinners: 'Past 10 Winners',
    previousJackpotWinners: 'Past 10 Jackpot Winners',
    previousBonusGameWinners: 'Past 10 Bonus Game Winners',
    previousHamsterRaceBigWinners: 'Past 10 Largest Winners',
    previous100GameWinners: 'Past 100 Winners',
    tableHeaders: {
      gameId: 'Game Id',
      stamp: 'Stamp',
      winners: 'Winners',
      room: 'Room'
    },
    winnerTemplate: '{username} - €{prize} ',
    winnersWindow: {
      tableHeaders: {
        game: 'Game',
        username: 'Name',
        prize: 'Prize'
      },
      freeze: 'freeze',
      title: 'Game Winners',
      copy: 'Copy'
    },
    popup: {
      title: '¡Enhorabuena!',
      message: '{username} ha ganado {prize} en {gameName}',
      extendedMessage: '{username} ha ganado {prize} en {gameName} {prizeType}'
    }
  },
  hamsterRace: {
    lastEigthWinnersTitle: 'Last 8 Winners',
    firstPlace: '1st',
    hamster: 'Hamster',
    wins: 'Wins',
    winners: {
      tableHeaders: {
        winningHamster: 'Winning Hamster'
      }
    }
  },
  rollercoaster: {
    lastSixCallsTitle: 'Last 6 Calls'
  },
  arcade: {
    winners: {
      tableHeaders: {
        winnerName: 'Winner Name',
        gameName: 'Game Name',
        prize: 'Prize',
        stamp: 'Stamp'
      }
    },
    gameNameFormat: '{gameName}'
  },
  quizQuids: {
    tableHeaders: {
      winnerName: 'Winner Name',
      chatModeratorName: 'Chatmod Name',
      stamp: 'Stamp'
    }
  },
  pictureBingo: {
    winners: {
      tableHeaders: {
        theme: 'Theme'
      }
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/plugins/localisation/languages/es/game.js
// module id = X1ko
// module chunks = 1